import React from "react"
import { Box, Flex } from "rebass"

import { ArrowLink } from "./arrow-link"

const Page = ({
  anchor,
  nextLink,
  photo,
  title,
  credits,
  lyrics,
  mobilePhoto,
}) => {
  return (
    <Flex
      as="section"
      id={anchor}
      bg="#290000"
      color="#fffdba"
      height={["auto", "100vh"]}
      p={4}
      sx={{
        position: "relative",
      }}
    >
      {nextLink && (
        <Box
          display={["none", "block"]}
          sx={{
            position: "absolute",
            bottom: "8px",
            width: "100%",
            right: 0,
            textAlign: "center",
          }}
        >
          <ArrowLink href={nextLink} />
        </Box>
      )}
      <Box
        display={["flex", "grid"]}
        width="100%"
        sx={{
          flexDirection: "column",
          gridTemplateColumns: "1fr 1.5fr",
          gridTemplateRows: "100%",
          gridGap: "16px",
        }}
      >
        <Box mb={3} display={["block", "none"]}>
          {mobilePhoto}
        </Box>
        <Box
          display={["none", "block"]}
          overflow="hidden"
          height="100%"
          width="100%"
          sx={{ zIndex: 20 }}
        >
          {photo}
        </Box>
        <Flex flexDirection="column">
          <Box
            overflow="hidden"
            display="grid"
            sx={{
              gridTemplateColumns: "1fr 1fr",
              gridGap: "16px",
            }}
          >
            <Box maxHeight={[400, "100%"]} overflowY="auto">
              <Box
                fontFamily="body"
                fontSize={1}
                sx={{
                  p: {
                    "&:first-of-type": {
                      marginTop: 0,
                    },
                  },
                }}
              >
                {lyrics}
              </Box>
            </Box>
            <Box
              fontFamily="body"
              fontSize={1}
              sx={{
                p: {
                  "&:first-of-type": {
                    marginTop: 0,
                  },
                },
              }}
            >
              {credits}
            </Box>
          </Box>
          <Flex
            mt={4}
            flex={1}
            textAlign={["left", "right"]}
            justifyContent="flex-end"
            alignItems="flex-end"
          >
            {title}
          </Flex>
          {nextLink && (
            <Box
              display={["block", "none"]}
              sx={{
                width: "100%",
                mt: 4,
                right: 0,
                textAlign: "center",
              }}
            >
              <ArrowLink href={nextLink} />
            </Box>
          )}
        </Flex>
      </Box>
    </Flex>
  )
}

export default Page
